export default "__VITE_ASSET__CH23BGzQ__"